import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const AugustSehriIftaar = ({districtDetails }) => {
  return <MonthlyTimeTable month={8} title="August Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default AugustSehriIftaar;
